import { render, staticRenderFns } from "./home-fotor.vue?vue&type=template&id=85d52a8c&scoped=true"
import script from "./home-fotor.vue?vue&type=script&lang=js"
export * from "./home-fotor.vue?vue&type=script&lang=js"
import style0 from "./home-fotor.vue?vue&type=style&index=0&id=85d52a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d52a8c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpenInBrowser: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/common/OpenInBrowser.vue').default})
